import { Container } from './style'

const Footer = () => {
    return (
        <Container>
            <div className="container-fluid">
                <p>Todos direitos reservados</p>
            </div>
        </Container>
    )
}

export default Footer
